import React from "react";
import "./OurAdvantages.css"


function OurAdvantages() {
    return (
    <div className="ouradvantages">
    <div className="ouradvantages_container">
    
    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Wide Range of Vehicles</h1>
        <p className = "ouradvantages-texts">We offer a diverse fleet of vehicles to cater to various customer preferences and needs. Whether you require a compact car for city commuting or a spacious SUV for a family vacation, we have the perfect vehicle to suit your requirements.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Competitive Pricing</h1>
        <p className = "ouradvantages-texts">We understand the importance of affordability when it comes to car rentals. Our services are competitively priced to provide excellent value for money. We regularly update our pricing to ensure that our customers get the best rates without compromising on quality.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Flexible Rental Options</h1>
        <p className = "ouradvantages-texts">We offer flexible rental options to accommodate your schedule. Whether you need a car for a few hours, a day, a weekend, or even an extended period, we have customizable rental plans to meet your specific needs. Our goal is to provide convenience and flexibility to our customers.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Easy Booking Process</h1>
        <p className = "ouradvantages-texts">We have simplified the booking process to make it quick and hassle-free. You can book a car rental through our user-friendly website or mobile app. With just a few clicks, you can choose your desired vehicle, select the rental duration, and make a reservation in minutes.</p>
    </div>
    
    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Excellent Customer Service</h1>
        <p className = "ouradvantages-texts">Our dedicated customer service team is committed to ensuring a seamless rental experience. We are available 24/7 to address any queries or concerns you may have before, during, or after your rental period. Our friendly and knowledgeable staff will go the extra mile to assist you and provide prompt solutions.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Convenient Pickup and Drop-off</h1>
        <p className = "ouradvantages-texts">We understand the importance of convenience when it comes to renting a car. We offer multiple pickup and drop-off locations, including airports, city centers, and popular destinations, making it easy for you to collect and return your rental vehicle at a location that suits you best.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Additional Services and Accessories</h1>
        <p className = "ouradvantages-texts">To enhance your rental experience, we offer a range of additional services and accessories. From GPS navigation systems and child safety seats to roadside assistance and insurance options, we have everything you need to make your journey comfortable and worry-free.</p>
    </div>

    <div className = "ouradvantages-item">
        <h1 className = "ouradvantages-titles">Trusted and Reliable</h1>
        <p className = "ouradvantages-texts">We have built a reputation for being a trusted and reliable car rental service provider. With years of experience in the industry, we have served countless satisfied customers who have appreciated our commitment to quality, professionalism, and customer satisfaction.</p>
    </div>
    </div>
    </div>
    )
}

export default OurAdvantages;
